export default __webpack_public_path__ + "static/media/exclusive-mini.59e8c87f.jpg";